import {createRouter, createWebHistory} from 'vue-router'
import Login from '../components/Login.vue'
import Pairing from '../components/Pairing.vue'
import HomeList from '../components/HomeList.vue'
import Control from '../components/Control.vue'
import Home from '../components/Home.vue'
import GroupCreate from '../components/GroupCreate.vue'
import HomeMVP from "../components/HomeMVP.vue";

const routes = [
    {path: '/', name: 'login', component: Login},
    {path: '/login', name: 'login', component: Login},
    {path: '/home', name: 'home', component: HomeMVP, meta: {requiresAuth: true}},
    {path: '/pair', name: 'pair', component: Pairing, meta: {requiresAuth: true}},
    {path: '/tvs', name: 'tvs', component: HomeList, meta: {requiresAuth: true}},
    {path: '/control/:tvId', name: 'control', component: Control, meta: {requiresAuth: true}},
    {path: '/control/group/:groupId', component: Control, meta: {requiresAuth: true}},
    {path: '/groups/new', name: 'groupCreate', component: GroupCreate, meta: {requiresAuth: true}},
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
    // Check for pairing code URL param (BGN TV pairing scanned from QR code)
    if (to.query.code) {
        sessionStorage.setItem('pending_pairing_code', to.query.code)

        const newQuery = {...to.query}
        delete newQuery.code
        return next({...to, query: newQuery})
    }

    const isLoggedIn = !!sessionStorage.getItem('auth_token')

    if (isLoggedIn && (to.name === 'login' || to.path === '/')) {
        return next({name: 'home'})
    }

    if (to.meta.requiresAuth && !isLoggedIn) {
        if (!isLoggedIn) return next({name: 'login'})
    }
    next()
})

export default router
